import { Helmet } from "react-helmet-async";

const SITE = "Finance Topia";
const BASE_URL = process.env.REACT_APP_SITE_URL || process.env.REACT_APP_BACKEND_URL || "";

// Prevent </script> breakout when embedding JSON in a <script> block.
const safeJsonLd = (obj) =>
  JSON.stringify(obj)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");

export default function SEO({
  title,
  description,
  keywords,
  image,
  url,
  type = "website",
  publishedTime,
  jsonLd,
}) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Independent Finance & Investing Journalism`;
  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL;
  const desc =
    description ||
    "Independent, editorial-grade coverage of investing, personal finance, cryptocurrency, and markets. Written by CFA-trained editors.";
  const img = image || `${BASE_URL}/og-default.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={img} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">
          {safeJsonLd(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
